import React, { Component } from 'react';
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
// import { Link } from 'react-router-dom';

import { history } from '../../state/store';

import StripeApi from '../../api/stripe';

import { Button } from '../shared/Button';
import { Message } from '../shared/Message';

class PaymentForm extends Component {
  constructor(props) {
    super(props);
    // console.log('PROPS IN CONSTRUCTOR', props);
    this.state = {
      emailError: '',
      numberError: '',
      expireError: '',
      cvcError: '',
      successMessage: '',
      completeInputs: [],
      isbusy: false,
      email: '',
      initialPrice: 1,
      initialNumber: 0,
      annualPrice: 1,
      annualCoupon: '',
      annualCount: 0,
      annualCost: 0,
      initialCost: 0,
      userDetails: {},
      totalNum: 0,
      disabled: false,
      title: '',
      plan: '',
    };
    this.goBack = this.goBack.bind(this);
    this.cancelHandler = this.cancelHandler.bind(this);
    this.catchStripeActivity = this.catchStripeActivity.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.planChange = this.planChange.bind(this);
    this.planChangeAnnual = this.planChangeAnnual.bind(this);
    this.changeInitialCount = this.changeInitialCount.bind(this);
    this.changeAnnualCount = this.changeAnnualCount.bind(this);
    this.getStateOrPropVal = this.getStateOrPropVal.bind(this);
  }

  getStateOrPropVal(name) {
    if (this.state[name] && this.state[name] !== '') {
      return this.state[name];
    } else if (this.state.userDetails && this.state.userDetails[name]) {
      return this.state.userDetails[name];
    } else {
      if (this.props.vals) {
        if (this.props.vals[name]) {
          this.setState({ [name]: this.props.vals[name] });
        }
      }
    }
    return null;
  }
  componentDidMount() {
    this.planChange('default_initial');
    this.planChangeAnnual('default_annual');
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    let updates = {};
    let disabled = false;
    // console.log(this.props.vals, this.state.coupon)
    if (this.props.vals && this.props.vals.title && this.props.vals.title !== this.state.title) {
      updates.title = this.props.vals.title;
      updates.disabled = disabled;
    }
    if (this.props.vals && this.props.vals.coupon && this.props.vals.coupon !== this.state.coupon) {
      console.log('UPDATE COUPON');
      updates.coupon = this.props.vals.coupon;
      updates.disabled = disabled;
      this.planChange(updates.coupon);
    }
    if (this.props.vals && this.props.vals.annualCoupon && this.props.vals.annualCoupon !== this.state.annualCoupon) {
      console.log('UPDATE ANNUAL COUPON');
      updates.annualCoupon = this.props.vals.annualCoupon;
      updates.disabled = disabled;
      this.planChangeAnnual(updates.annualCoupon);
    }
    if (this.props.vals && this.props.vals.plan && this.props.vals.plan !== this.state.plan) {
      updates.plan = this.props.vals.plan;
      updates.disabled = true;
      this.planChange(updates.plan);
      console.log('disable true?');
    }
    if (Object.keys(updates).length > 0) {
      this.setState(updates);
    }
    console.log('plan... ', this.state.plan);
  }
  goBack() {
    history.goBack();
  }

  cancelHandler() {
    this.setState({
      emailError: '',
      numberError: '',
      expireError: '',
      cvcError: '',
      successMessage: '',
      completeInputs: [],
      isbusy: false,
      email: '',
      initialPrice: 1,
      initialNumber: 0,
      annualPrice: 1,
      annualCoupon: '',
      annualCount: 0,
      annualCost: 0,
      initialCost: 0,
      userDetails: {},
      comapny: '',
      totalNum: 0,
    });
  }
  catchStripeActivity(evt, stripeError) {
    const { error } = evt;
    const { completeInputs } = this.state;
    if (error) {
      this.setState({
        [stripeError]: error.message,
      });
    } else {
      this.setState({
        [stripeError]: '',
      });
    }
    if (evt.complete) {
      const newCompletes = Object.assign(completeInputs);

      if (completeInputs.indexOf(evt.elementType) === -1) {
        newCompletes.push(evt.elementType);
      }
      this.setState({
        completeInputs: newCompletes,
      });
    } else {
      if (completeInputs.indexOf(evt.elementType) > -1) {
        const newCompletes = completeInputs.filter(comp => comp !== evt.elementType);

        this.setState({
          completeInputs: newCompletes,
        });
      }
    }
  }

  async planChange(value) {
    // console.log('PlanChange:', 'coupon:', value, 'plan:', this.state.plan);
    let price = await StripeApi.getPrice(value, this.state.plan, this.state.annualCheck);
    this.setState({
      initialPrice: price.data.price / 100,
      coupon: value,
      initialCost: ((price.data.price / 100) * this.state.initialNumber).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
      totalCost: ((price.data.price / 100) * this.state.initialNumber + this.state.annualPrice * this.state.annualCount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
    });
  }
  async planChangeAnnual(value) {
    let price = await StripeApi.getPrice(value, this.state.plan, this.state.annualCheck);
    this.setState({
      annualPrice: price.data.price / 100,
      annualCoupon: value,
      annualCost: ((price.data.price / 100) * this.state.annualCount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
      totalCost: ((price.data.price / 100) * this.state.annualCount + this.state.initialPrice * this.state.initialNumber).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
    });
  }

  calculateCost(type) {
    let p, count;
    if (!type || type === 'initial') {
      p = this.state.initialPrice.price;
      count = this.state.initialNumber;
    } else if (type === 'annual') {
      p = this.state.annualPrice.price;
      count = this.state.annualCount;
    }

    if (!p || !count) {
      return 0;
    }
    if (Array.isArray(p)) {
      let rtv = 0;
      let lim = 0;
      let last_lim = 0;
      for (let i = 0; i < p.length; i++) {
        let val = p[i].amount;
        lim = p[i].up_to;
        let curr_count = count - last_lim;
        if (lim && curr_count >= lim) {
          rtv += val * Math.min(curr_count, lim);
        } else {
          rtv += Math.max(0, curr_count) * val;
        }
        last_lim = lim;
      }
      return rtv / 100;
    } else {
      return (count * p) / 100;
    }
  }
  setUserDetails(key, value) {
    let details = this.state.userDetails;
    details[key] = value;
    this.setState({ userDetails: details });
  }

  async handleSubmit() {
    // const user = AuthService.getUser();
    const email = this.state.email;
    this.setState({ isbusy: true });

    const token = await this.props.stripe.createToken({ name: email });
    let token_id = token.token.id;
    let count = this.state.initialNumber;
    let coupon = this.state.coupon;
    let annual_count = this.state.annualCount;
    let annual_coupon = this.state.annualCoupon;
    let tos = this.state.termsCB;
    let userDetails = this.state.userDetails;
    let annualPurchase = this.state.annualCheck;
    let plan = this.state.plan;
    try {
      // debugger;
      await StripeApi.handlePurchase(email, token_id, count, coupon, annual_count, annual_coupon, tos, userDetails, annualPurchase, plan);
      alert('Your purchase has succeeded. Please check your email for further instructions. You will now be redirected to the confirmation page.');
      window.location.href = '/initial/account/confirm';
      // console.log(result);
      // this.setState({
      //     successMessage: `Your account has been created, please check your ${email} for further instructions`,
      //     isbusy: false
      // });
    } catch (error) {
      // debugger;
      console.error(error);
      this.setState({
        emailError: 'There was an error in your request. Please check your information and try again.',
      });
    }
    this.setState({ isbusy: false });

    //        handlePurchase(/*payload:*/ stripeEmail, stripeToken, /*query:*/ amt, coupon, tos)

    // const newCard = await StripeApi.updateCardInfo(source);
    // let cardEnding;
    // newCard.data.sources.data.forEach(src => {
    //     if (src.id === newCard.data.default_source) {
    //         cardEnding = src.card.last4;
    //     }
    // });
    // this.setState({
    //     successMessage: `Card ****${cardEnding} has been made your default source for payment.`,
    //     isbusy: false
    // });
    this._element1.clear();
    this._element2.clear();
    this._element3.clear();
  }

  changeInitialCount(num) {
    if (num < 0) {
      num = 0;
    }
    num = Math.round(num);
    this.setState({
      initialNumber: num,
      initialCost: (this.state.initialPrice * num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
      totalNum: (this.state.annualCount + num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
      totalCost: (this.state.initialPrice * num + this.state.annualPrice * this.state.annualCount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
    });
    // this.forceUpdate(() => { "initial update forced" });
  }
  changeAnnualCount(num) {
    if (num < 0) {
      num = 0;
    }
    num = Math.round(num);
    this.setState({
      annualCount: num,
      annualCost: (this.state.annualPrice * num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
      totalNum: (num + this.state.initialNumber).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
      totalCost: (this.state.annualPrice * num + this.state.initialPrice * this.state.initialNumber).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
    });
    // this.forceUpdate(() => { "annual update forced" });
  }
  render() {
    const { emailError, numberError, expireError, cvcError, successMessage, completeInputs, isbusy } = this.state;
    return (
      <div className="PurchaseForm">
        <div className="payment">
          <div className="form__Intro">
            <div className="form__Intro__div Cost">
              {/* <h4>Cost:</h4> */}
              <table>
                <thead>
                  <th>Item</th>
                  <th>Count</th>
                  <th>Cost</th>
                  <th>Total</th>
                </thead>
                <tbody>
                  <tr>
                    {console.log('title', this.state.title)}
                    <td className="table__text">{this.state.title !== null && this.state.title !== '' ? this.state.title : 'PCMHGuide License'} </td>
                    <td>{this.state.initialNumber || 0}</td>
                    <td>${this.state.initialPrice}</td>
                    <td>${this.state.initialCost}</td>
                  </tr>
                  <tr className="hidden">
                    <td className="table__text">PCMHGuide Annual Reporting</td>
                    <td>{this.state.annualCount || 0}</td>
                    <td>${this.state.annualPrice}</td>
                    <td>${this.state.annualCost}</td>
                  </tr>
                  <tr className="hidden">
                    <td className="table__text">Total</td>
                    <td></td>
                    <td></td>
                    <td>${this.state.totalCost}</td>
                  </tr>
                </tbody>
              </table>
              <div className="form__Intro__div text__bottom">
                {/* <h4>Select Product and License Count:</h4> */}
                <span className="hidden text__callout">Pay annually (10% off) </span>
                <label class="switch">
                  <input
                    className="hidden"
                    disabled={this.state.disabled ? 'disabled' : ''}
                    value={this.state.annualCheck}
                    onChange={e => {
                      this.setState({ annualCheck: e.target.checked }, () => {
                        this.planChange('default_initial');
                        this.planChangeAnnual('default_annual');
                      });
                    }}
                    type="checkbox"
                  />
                  <span className="hidden" class="hidden slider round"></span>
                </label>
              </div>
            </div>
            <div className="form__Intro__div validation">
              <Message error={emailError} />
              <Message error={numberError} />
              <Message error={expireError} />
              <Message error={cvcError} />
              <Message success={successMessage} />
            </div>
          </div>

          <div className="form__container">
            <fieldset className="Form__fieldset">
              <legend>License Details</legend>
              <div className="row">
                <div className="form__wrapper column">
                  <label>{this.state.title != null ? this.state.title : 'PCMHGuide Licenses'}</label>
                  <div className="form__input StripeElement__container num__input">
                    <input
                      /*disabled={(this.state.disabled) ? "disabled" : ""}*/ type="number"
                      defaultValue={this.getStateOrPropVal('initialNumber')}
                      value={this.state.initialNumber}
                      onChange={e => this.changeInitialCount(e.target.value)}
                    />
                  </div>
                </div>
                <label className="hidden">Initial Purchase Code (optional)</label>
                <div className="hidden StripeElement__container num__input">
                  <input
                    onChange={e => {
                      this.planChange(e.target.value, 'initial');
                    }}
                    onReady={c => (this.initialPurchaseCode = c)}
                  />
                </div>

                <div className="hidden form__wrapper column">
                  <label>PCMHGuide Annual Reporting Licenses</label>
                  <div className="form__input StripeElement__container num__input">
                    <input disabled={this.state.disabled ? 'disabled' : ''} type="number" defaultValue={this.getStateOrPropVal('annualCount')} value={this.state.annualCount} onChange={e => this.changeAnnualCount(e.target.value)} />
                  </div>
                </div>
                <label className="hidden">Annual Purchase Code (optional)</label>
                <div className="hidden StripeElement__container num__input">
                  <input
                    onChange={e => {
                      this.planChangeAnnual(e.target.value, 'annual');
                    }}
                    onReady={c => (this.annualCoupon = c)}
                  />
                </div>
              </div>
            </fieldset>
            <fieldset className="Form__fieldset">
              {/* eslint-disable jsx-a11y/anchor-has-content*/}
              <a name="customer"></a>
              {/* eslint-enable jsx-a11y/anchor-has-content*/}
              <legend>Customer Details</legend>
              <div className="row">
                <div className="form__wrapper column">
                  <label>
                    <i className="fa fa-mailbox"></i> Email
                  </label>
                  <div className="StripeElement__container">
                    <input
                      type="email"
                      defaultValue={this.getStateOrPropVal('email')}
                      value={this.state.email}
                      onChange={e => {
                        this.setState({ email: e.target.value });
                      }}
                    />
                  </div>
                </div>
                <div className="form__wrapper column">
                  {/*<!--- NEW ONES -->*/}
                  <label>
                    <i className="fa fa-email"></i> Name
                  </label>
                  <div className="StripeElement__container">
                    <input type="text" defaultValue={this.getStateOrPropVal('name')} value={this.state.userDetails.name} onChange={e => this.setUserDetails('name', e.target.value)} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form__wrapper column">
                  <label>
                    <i className="fa fa-email"></i> Company
                  </label>
                  <div className="StripeElement__container">
                    <input type="text" defaultValue={this.getStateOrPropVal('company')} value={this.state.userDetails.company} onChange={e => this.setUserDetails('company', e.target.value)} />
                  </div>
                </div>
                <div className="form__wrapper column">
                  <label>
                    <i className="fa fa-email"></i> Phone
                  </label>
                  <div className="StripeElement__container">
                    <input type="text" defaultValue={this.getStateOrPropVal('phone')} value={this.state.userDetails.phone} onChange={e => this.setUserDetails('phone', e.target.value)} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form__wrapper column">
                  <label>
                    <i className="fa fa-email"></i> Address{' '}
                  </label>
                  <div className="StripeElement__container">
                    <input type="text" defaultValue={this.getStateOrPropVal('address')} value={this.state.userDetails.address} onChange={e => this.setUserDetails('address', e.target.value)} />
                  </div>
                </div>
                <div className="form__wrapper column">
                  <label>
                    <i className="fa fa-email"></i> City
                  </label>
                  <div className="StripeElement__container">
                    <input type="text" defaultValue={this.getStateOrPropVal('city')} value={this.state.userDetails.city} onChange={e => this.setUserDetails('city', e.target.value)} />
                  </div>
                </div>
                <div className="form__wrapper column">
                  <label>
                    <i className="fa fa-email"></i> State
                  </label>
                  <div className="StripeElement__container">
                    <input type="text" defaultValue={this.getStateOrPropVal('state')} value={this.state.userDetails.state} onChange={e => this.setUserDetails('state', e.target.value)} />
                  </div>
                </div>
              </div>
            </fieldset>
            {/*End new stuff*/}

            <fieldset className="Form__fieldset">
              <legend>Payment Details</legend>
              <div className="row">
                <div className="form__wrapper column">
                  <label>
                    <i className="fa fa-credit-card"></i> Card number
                  </label>
                  <div className="StripeElement__container">
                    <CardNumberElement onChange={e => this.catchStripeActivity(e, 'numberError')} onReady={c => (this._element1 = c)} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form__wrapper column">
                  <label>Expiration date</label>
                  <div className="StripeElement__container">
                    <CardExpiryElement onChange={e => this.catchStripeActivity(e, 'expireError')} onReady={c => (this._element2 = c)} />
                  </div>
                </div>
                <div className="form__wrapper column">
                  <label>CVC</label>
                  <div className="StripeElement__container">
                    <CardCVCElement onChange={e => this.catchStripeActivity(e, 'cvcError')} onReady={c => (this._element3 = c)} />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="form__cb">
            <input
              onClick={e => {
                this.setState({ termsCB: e.target.checked });
              }}
              type="checkbox"
            />
            <label for="termsCB">
              <h5>
                I agree to the{' '}
                <a target="_" href="public/files/cloud_services_agreement.pdf">
                  Terms and Conditions
                </a>
              </h5>
            </label>
          </div>
          <div className="form__buttons">
            <Button insufficientData={completeInputs.length !== 3 || !this.state.termsCB || !this.state.email || !this.state.totalNum} type="submit" defaultText="Submit" busyText="Updating" isbusy={isbusy} onClick={this.handleSubmit} />
            <Button onClick={this.cancelHandler} defaultText="Cancel" />
          </div>
        </div>
      </div>
    );
  }
}

export default injectStripe(PaymentForm);



// WEBPACK FOOTER //
// ./src/components/purchase/PurchaseForm.js